import { createClient } from "https://esm.sh/@supabase/supabase-js@2";
import qrcodeGen from "https://esm.sh/qrcode-generator@1.4.4";

const SUPA_URL = "https://mmggxmwuwvlrnszxacgu.supabase.co";
const ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1tZ2d4bXd1d3Zscm5zenhhY2d1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM1MzMxMDksImV4cCI6MjA5OTEwOTEwOX0.IO_kGB8ohVce842vfvzx04Bq0qtOKf41zmj76963D5A";
const FN = SUPA_URL + "/functions/v1";
const supabase = createClient(SUPA_URL, ANON);

// AI reveal video: 'ai' = generate the clip from the photo after purchase (occasion template),
// 'upload' = the customer uploads their own clip. Launched 2026-10-28 (was hidden behind ?ai=1).
const PM_AI_VIDEO_ENABLED = true;
const PM_AI_TEMPLATES = [
  // sample = a real example clip made with the same template (Shopify Files, muted, 480px).
  { id: "general", emoji: "✨", title: "התמונה קמה לחיים", hint: "ניצוצות זהב", sample: "https://cdn.shopify.com/s/files/1/0768/0422/7210/files/pm-ai-sample-general.mp4?v=1793128887" },
  { id: "birthday", emoji: "🎂", title: "יום הולדת", hint: "גשם של קונפטי", sample: "https://cdn.shopify.com/s/files/1/0768/0422/7210/files/pm-ai-sample-birthday-v2.mp4?v=1793137404" },
  { id: "proposal", emoji: "💍", title: "יום נישואין", hint: "זיקוקים בשקיעה", sample: "https://cdn.shopify.com/s/files/1/0768/0422/7210/files/pm-ai-sample-anniversary-older.mp4?v=1793180545" },
  { id: "anniversary", emoji: "❤️", title: "זוגיות", hint: "עלי ורדים", sample: "https://cdn.shopify.com/s/files/1/0768/0422/7210/files/pm-ai-sample-anniversary.mp4?v=1793128887" },
  { id: "baby", emoji: "🦋", title: "ילדים ותינוקות", hint: "פרפרים", sample: "https://cdn.shopify.com/s/files/1/0768/0422/7210/files/pm-ai-sample-baby-v3.mp4?v=1793405432" },
  { id: "family", emoji: "🫧", title: "משפחה", hint: "בועות סבון", sample: "https://cdn.shopify.com/s/files/1/0768/0422/7210/files/pm-ai-sample-family.mp4?v=1793128887" },
];
// null until the customer opens one of the two sections (only when the AI option is enabled).
let pmVideoMode = PM_AI_VIDEO_ENABLED ? null : "upload";
let pmVideoTemplate = "general";

const PM_VARIANT_PIECES = {
  "49418647994506": 50,
  "49418648027274": 100,
  "49418648060042": 150,
  "49848652038282": 300,
};
const PM_BOX_SPECS = {
  50: {
    puzzleSizeCm: "35x25", boxSizeCm: "18x13", width: 1535, height: 2126,
    photo: [350, 682, 1420, 2001], badge: [1136, 1693, 1415, 1972],
    empty: window.PM_THEME_ASSETS.box18Empty,
    overlay: window.PM_THEME_ASSETS.box18Overlay,
    landscapePhoto: [456, 479, 1939, 1397], landscapeBadge: [1722, 1164, 1911, 1356],
    landscapeSideIcons: [[179, 470, 340, 640], [179, 768, 340, 939], [179, 1078, 340, 1249]],
    landscapeEmpty: window.PM_THEME_ASSETS.box18LandscapeEmpty,
    landscapeOverlay: window.PM_THEME_ASSETS.box18LandscapeOverlay,
  },
  100: {
    puzzleSizeCm: "40x28", boxSizeCm: "18x13", width: 1535, height: 2126,
    photo: [350, 682, 1420, 2001], badge: [1136, 1693, 1415, 1972],
    empty: window.PM_THEME_ASSETS.box18Empty,
    overlay: window.PM_THEME_ASSETS.box18Overlay,
    landscapePhoto: [456, 479, 1939, 1397], landscapeBadge: [1722, 1164, 1911, 1356],
    landscapeSideIcons: [[179, 470, 340, 640], [179, 768, 340, 939], [179, 1078, 340, 1249]],
    landscapeEmpty: window.PM_THEME_ASSETS.box18LandscapeEmpty,
    landscapeOverlay: window.PM_THEME_ASSETS.box18LandscapeOverlay,
  },
  150: {
    puzzleSizeCm: "35x25", boxSizeCm: "21.5x17.5", width: 2067, height: 2539,
    photo: [459, 780, 1880, 2382], badge: [1498, 1993, 1868, 2363],
    empty: window.PM_THEME_ASSETS.box215Empty,
    overlay: window.PM_THEME_ASSETS.box215Overlay,
    landscapePhoto: [545, 644, 2316, 1881], landscapeBadge: [2057, 1567, 2282, 1826],
    landscapeSideIcons: [[214, 632, 407, 863], [214, 1033, 407, 1265], [214, 1450, 407, 1682]],
    landscapeEmpty: window.PM_THEME_ASSETS.box215LandscapeEmpty,
    landscapeOverlay: window.PM_THEME_ASSETS.box215LandscapeOverlay,
  },
  300: {
    puzzleSizeCm: "52x38", boxSizeCm: "27.5x21.5", width: 2539, height: 3248,
    photo: [583, 1042, 2362, 2955], badge: [1797, 2411, 2297, 2911],
    empty: window.PM_THEME_ASSETS.box295Empty,
    overlay: window.PM_THEME_ASSETS.box295Overlay,
    landscapePhoto: [748, 792, 2941, 2311], landscapeBadge: [2586, 1926, 2894, 2243],
    landscapeSideIcons: [[294, 779, 558, 1057], [294, 1272, 558, 1551], [294, 1785, 558, 2064]],
    landscapeEmpty: window.PM_THEME_ASSETS.box295LandscapeEmpty,
    landscapeOverlay: window.PM_THEME_ASSETS.box295LandscapeOverlay,
  },
};

// ---- Factory package files: puzzle/box/card as single-page PDFs + one combined ZIP ----
// Visually mirrors src/components/GreetingCard.tsx (same colors/layout as the admin panel
// and /card page) but is drawn with plain Canvas 2D instead of cloning that DOM — html2canvas's
// hidden-iframe cloning was observed to hang indefinitely on this exact storefront page
// under real conditions — a checkout-blocking failure mode that a pure canvas.drawImage/
// fillText approach (the same technique createBoxArtworkFile already uses reliably) avoids
// entirely, since nothing here waits on an iframe or an external stylesheet to "settle".

let rubikFontPromise = null;
function ensureRubikFont() {
  if (!rubikFontPromise) {
    rubikFontPromise = (async () => {
      if (!document.querySelector("link[data-pm-rubik]")) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700;800&display=swap";
        link.setAttribute("data-pm-rubik", "1");
        document.head.appendChild(link);
      }
      // Cap the font wait: on a flaky network the Google Fonts request (and therefore
      // document.fonts.ready) can hang forever, which would silently stall the whole ZIP build.
      // A timeout lets the card draw with the fallback font instead of hanging the order.
      try {
        await pmWithTimeout(Promise.all([
          document.fonts.load("800 60px Rubik"),
          document.fonts.load("700 45px Rubik"),
          document.fonts.load("800 33px Rubik"),
          document.fonts.load("600 28px Rubik"),
          document.fonts.load("500 60px Rubik"),
        ]), 5000);
      } catch (e) { /* best effort, drawing still proceeds with fallback font */ }
      if (document.fonts && document.fonts.ready) {
        try { await pmWithTimeout(document.fonts.ready, 5000); } catch (e) { /* non-fatal */ }
      }
    })();
  }
  return rubikFontPromise;
}

function pmRoundedRect(ctx, x, y, w, h, r) {
  if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); return; }
  const rr = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.arcTo(x + w, y, x + w, y + h, rr);
  ctx.arcTo(x + w, y + h, x, y + h, rr);
  ctx.arcTo(x, y + h, x, y, rr);
  ctx.arcTo(x, y, x + w, y, rr);
  ctx.closePath();
}

function pmWrapText(ctx, text, maxWidth) {
  const paragraphs = String(text || "").split("\n");
  const lines = [];
  for (const para of paragraphs) {
    if (!para) { lines.push(""); continue; }
    const words = para.split(" ");
    let current = "";
    for (const word of words) {
      const test = current ? current + " " + word : word;
      if (current && ctx.measureText(test).width > maxWidth) {
        lines.push(current);
        current = word;
      } else {
        current = test;
      }
    }
    if (current) lines.push(current);
  }
  return lines;
}

function pmDrawQr(ctx, scanCode, x, y, size) {
  const qr = qrcodeGen(0, "H");
  qr.addData("https://puzzlemagic.vercel.app/gift?code=" + encodeURIComponent(scanCode || ""));
  qr.make();
  const n = qr.getModuleCount();
  const px = size / n;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(x, y, size, size);
  ctx.fillStyle = "#000000";
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (qr.isDark(r, c)) ctx.fillRect(x + c * px, y + r * px, Math.ceil(px), Math.ceil(px));
    }
  }
}

async function buildCardCanvas(recipient, sender, message, scanCode) {
  await ensureRubikFont();
  const scale = 3;
  const W = 520 * scale, H = 738 * scale;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  const FONT = "'Rubik', sans-serif";
  // fs() scales font sizes by `scale` too. Previously only x/y positions were scaled and the
  // font sizes were left at their logical px, so all text rendered 3x too small on the 3x canvas.
  const fs = (px) => Math.round(px * scale) + "px";
  const padX = 38 * scale;
  const contentW = W - padX * 2;

  // Square corners: a print page is cut straight, so no rounded corners / clip on the outer card.
  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, "#ffffff");
  bg.addColorStop(0.55, "#fdfaf0");
  bg.addColorStop(1, "#fbf4e4");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  const topBar = ctx.createLinearGradient(0, 0, W, 0);
  topBar.addColorStop(0, "#b98cf2");
  topBar.addColorStop(0.5, "#a874ef");
  topBar.addColorStop(1, "#d7b8ff");
  ctx.fillStyle = topBar;
  ctx.fillRect(0, 0, W, 10 * scale);

  ctx.strokeStyle = "#efe6cf";
  ctx.lineWidth = 1 * scale;
  ctx.strokeRect(ctx.lineWidth / 2, ctx.lineWidth / 2, W - ctx.lineWidth, H - ctx.lineWidth);

  // Decorative artwork copied exactly from the canonical GreetingCard component.
  const piecePath = new Path2D("M10 10 L38 10 C30 -14 70 -14 62 10 L90 10 L90 38 C114 30 114 70 90 62 L90 90 L62 90 C70 66 30 66 38 90 L10 90 L10 62 C-14 70 -14 30 10 38 Z");
  function drawPiece(boxLeft, boxTop, rotation, color, opacity) {
    const boxSize = 118 * scale;
    const pathScale = boxSize / 136;
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.fillStyle = color;
    ctx.translate(boxLeft + boxSize / 2, boxTop + boxSize / 2);
    ctx.rotate(rotation * Math.PI / 180);
    ctx.translate(-boxSize / 2, -boxSize / 2);
    ctx.scale(pathScale, pathScale);
    ctx.translate(18, 18);
    ctx.fill(piecePath);
    ctx.restore();
  }
  drawPiece(W - 14 * scale - 118 * scale, 30 * scale, -14, "#8ed35f", 0.55);
  drawPiece(12 * scale, H - 96 * scale - 118 * scale, 12, "#6cc24a", 0.5);

  const confetti = [
    { top: 5, left: 12, c: "#a874ef", r: -20, w: 13, h: 7 },
    { top: 8, left: 82, c: "#7ed957", r: 35, w: 8, h: 8, round: true },
    { top: 4, left: 62, c: "#ff7eb6", r: -40, w: 7, h: 7, round: true },
    { top: 20, left: 6, c: "#4ecdc4", r: 25, w: 11, h: 6 },
    { top: 18, left: 92, c: "#ffc94d", r: -15, w: 8, h: 8, round: true },
    { top: 30, left: 88, c: "#a874ef", r: 40, w: 10, h: 6 },
    { top: 34, left: 10, c: "#ff7eb6", r: -25, w: 9, h: 6 },
    { top: 2, left: 32, c: "#7ed957", r: 10, w: 7, h: 7, round: true },
    { top: 24, left: 70, c: "#4ecdc4", r: -30, w: 6, h: 6, round: true },
    { top: 88, left: 14, c: "#ffc94d", r: 20, w: 11, h: 6 },
    { top: 92, left: 80, c: "#a874ef", r: -35, w: 9, h: 6 },
    { top: 85, left: 50, c: "#7ed957", r: 15, w: 7, h: 7, round: true },
  ];
  for (const item of confetti) {
    const width = item.w * scale, height = item.h * scale;
    const x = item.left / 100 * W + width / 2;
    const y = item.top / 100 * H + height / 2;
    ctx.save();
    ctx.fillStyle = item.c;
    ctx.translate(x, y);
    ctx.rotate(item.r * Math.PI / 180);
    if (item.round) {
      ctx.beginPath();
      ctx.arc(0, 0, width / 2, 0, Math.PI * 2);
      ctx.fill();
    } else {
      ctx.fillRect(-width / 2, -height / 2, width, height);
    }
    ctx.restore();
  }

  ctx.textAlign = "center";
  ctx.direction = "rtl";
  const cx = W / 2;
  let y = 42 * scale + 44 * scale * 0.85;

  ctx.font = fs(44) + " " + FONT;
  ctx.fillText("\u{1F381}", cx, y);
  // Emoji glyphs extend well below their text baseline in several browsers. Keep an
  // explicit visual gap so the recipient name can never touch the gift artwork.
  y += 60 * scale;

  ctx.font = "800 " + fs(44) + " " + FONT;
  ctx.fillStyle = "#2e2a39";
  const recipientLines = pmWrapText(ctx, recipient || "—", contentW);
  for (const line of recipientLines) { ctx.fillText(line, cx, y); y += 50 * scale; }
  y += 6 * scale;

  const dividerGrad = ctx.createLinearGradient(cx - 37 * scale, 0, cx + 37 * scale, 0);
  dividerGrad.addColorStop(0, "#b98cf2");
  dividerGrad.addColorStop(1, "#a874ef");
  ctx.fillStyle = dividerGrad;
  ctx.fillRect(cx - 37 * scale, y, 74 * scale, 4 * scale);
  y += 4 * scale + 34 * scale;

  ctx.font = "500 " + fs(20) + " " + FONT;
  ctx.fillStyle = "#4a4550";
  const messageLines = pmWrapText(ctx, message || " ", contentW - 8 * scale);
  for (const line of messageLines) { ctx.fillText(line, cx, y); y += 33 * scale; }
  y += 26 * scale;

  if (sender) {
    ctx.font = "600 " + fs(15) + " " + FONT;
    ctx.fillStyle = "#9a8fb0";
    ctx.fillText("מאת", cx, y);
    y += 26 * scale;
  }
  ctx.font = "700 " + fs(24) + " " + FONT;
  ctx.fillStyle = "#2e2a39";
  const senderLines = pmWrapText(ctx, sender || " ", contentW);
  for (const line of senderLines) { ctx.fillText(line, cx, y); y += 30 * scale; }

  if (scanCode) {
    const scanH = 230 * scale;
    const scanY = H - 34 * scale - scanH;
    const scanX = padX;
    const scanW = contentW;
    const scanGrad = ctx.createLinearGradient(scanX, scanY, scanX + scanW, scanY + scanH);
    scanGrad.addColorStop(0, "#f4ecff");
    scanGrad.addColorStop(1, "#eee3ff");
    ctx.fillStyle = scanGrad;
    pmRoundedRect(ctx, scanX, scanY, scanW, scanH, 18 * scale);
    ctx.fill();
    ctx.strokeStyle = "#e3d4ff";
    ctx.lineWidth = 1 * scale;
    pmRoundedRect(ctx, scanX, scanY, scanW, scanH, 18 * scale);
    ctx.stroke();

    const qrSize = 104 * scale;
    const qrPad = 8 * scale;
    const qrBoxX = cx - qrSize / 2 - qrPad;
    const qrBoxY = scanY + 16 * scale;
    ctx.fillStyle = "#ffffff";
    pmRoundedRect(ctx, qrBoxX, qrBoxY, qrSize + qrPad * 2, qrSize + qrPad * 2, 12 * scale);
    ctx.fill();
    pmDrawQr(ctx, scanCode, qrBoxX + qrPad, qrBoxY + qrPad, qrSize);

    let sy = qrBoxY + qrSize + qrPad * 2 + 18 * scale;
    ctx.font = "800 " + fs(18) + " " + FONT;
    ctx.fillStyle = "#6b3fd4";
    ctx.fillText("הפאזל מוכן? עכשיו הקסם מתחיל ✨", cx, sy);
    sy += 24 * scale;

    ctx.font = "500 " + fs(13.5) + " " + FONT;
    ctx.fillStyle = "#6a6478";
    const subLines = pmWrapText(ctx, "סרקו את הקוד, כוונו את המצלמה אל הפאזל וגלו את ההפתעה שלכם.", 300 * scale);
    for (const line of subLines) { ctx.fillText(line, cx, sy); sy += 20 * scale; }

    ctx.font = "600 " + fs(11) + " " + FONT;
    ctx.fillStyle = "#c9bda3";
    ctx.fillText("P U Z Z L E M A G I C", cx, scanY + scanH - 12 * scale);
  } else {
    // A photo-only order is a regular personal puzzle. Keep its greeting card clean and
    // never print a QR that cannot resolve to a reveal video.
    ctx.font = "600 " + fs(11) + " " + FONT;
    ctx.fillStyle = "#c9bda3";
    ctx.fillText("P U Z Z L E M A G I C", cx, H - 28 * scale);
  }

  return canvas;
}

async function blobToJpegBlob(blob, quality) {
  // Plain JPEG, no PDF wrapper: jsPDF's own PNG handling measured 6.6s on the box artwork
  // (pure-JS alpha parsing) vs ~300ms for the same pixels as a flat JPEG, and dropping the PDF
  // step entirely removes that cost plus a whole library load. A full-bleed factory print image
  // needs no transparency, so nothing is lost. Loading via an object URL (not a data: URL) also
  // skips a slow FileReader/base64 round trip.
  quality = quality || 0.9;
  const objectUrl = URL.createObjectURL(blob);
  let img;
  try {
    img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = () => reject(new Error("קריאת התמונה נכשלה"));
      im.src = objectUrl;
    });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0);
  return new Promise((resolve, reject) =>
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("יצירת JPEG נכשלה"))), "image/jpeg", quality)
  );
}

// Same content-bounds detection the box uses (pmContentBounds), but for the standalone puzzle
// print: crop away any near-white / transparent padding baked into the customer's photo so the
// factory doesn't print white bars on the sides. A clean photo has no padding → no crop.
async function cropContentJpeg(blob, quality) {
  quality = quality || 0.92;
  const objectUrl = URL.createObjectURL(blob);
  let img;
  try {
    img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = () => reject(new Error("קריאת התמונה נכשלה"));
      im.src = objectUrl;
    });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
  const bounds = pmContentBounds(img);
  const cx = bounds[0], cy = bounds[1], cw = bounds[2], ch = bounds[3];
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(cw));
  canvas.height = Math.max(1, Math.round(ch));
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, cx, cy, cw, ch, 0, 0, canvas.width, canvas.height);
  return new Promise((resolve, reject) =>
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("יצירת JPEG נכשלה"))), "image/jpeg", quality)
  );
}

function publicUrlFor(info) {
  return supabase.storage.from(info.bucket).getPublicUrl(info.path).data.publicUrl;
}

function pmOrientedSize(size, orientation) {
  const parts = String(size || "").match(/\d+(?:\.\d+)?/g);
  if (!parts || parts.length !== 2) return String(size || "").replace(/[^0-9x.]/gi, "");
  const first = Number(parts[0]), second = Number(parts[1]);
  const shortSide = Math.min(first, second), longSide = Math.max(first, second);
  return orientation === "landscape" ? longSide + "x" + shortSide : shortSide + "x" + longSide;
}

// Upload only the small A6 card from the browser. The server builds the large factory ZIP
// from the image and box already in Storage, so mobile never uploads the print files twice.
async function buildFactoryZip(recipient, sender, message, scanCode, meta) {
  const cardCanvas = await buildCardCanvas(recipient, sender, message, scanCode);
  const cardPng = await new Promise((resolve, reject) =>
    cardCanvas.toBlob((b) => (b ? resolve(b) : reject(new Error("יצירת כרטיס הברכה נכשלה"))), "image/png")
  );
  const cardInfo = await uploadFile(
    new File([cardPng], "Personal-card-A6-VERTICAL.png", { type: "image/png" }),
    "card_image",
  );
  const result = await pmWithTimeout(callFn("customer-build-factory-zip", {
    upload_code: meta.uploadCode,
    upload_id: meta.uploadId,
    orientation: meta.orientation,
    card: cardInfo,
    box: meta.box,
    video: meta.video || null,
  }), 120000);
  if (!result || !result.url) throw new Error("יצירת חבילת ההדפסה נכשלה");
  return result.url;
}

const $ = (id) => document.getElementById(id);
const overlay = $("pmUploadOverlay");
if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);
const trimOverlay = $("pmTrimOverlay");
if (trimOverlay && trimOverlay.parentNode !== document.body) document.body.appendChild(trimOverlay);
// Success message text is defined in the block markup; no runtime override needed.
const videoUploadHint = $("pmVideoLabel");
if (videoUploadHint) videoUploadHint.textContent = "לחצו להעלאה • עד 30 שניות";

// Put the heavier uploads first so their existing background-upload flow can
// run while the customer fills in the short text fields below them.
const imageDrop = $("pmImageDrop");
const videoDrop = $("pmVideoDrop");
const nameInput = $("pmName");
if (imageDrop && videoDrop && nameInput) {
  const formCard = nameInput.parentElement;
  const firstTextLabel = nameInput.previousElementSibling;
  const imageTitle = imageDrop.previousElementSibling;
  const videoTitle = videoDrop.previousElementSibling;
  const uploadElements = [imageTitle, imageDrop, $("pmImage"), videoTitle, videoDrop, $("pmVideo")];
  if (formCard && firstTextLabel && uploadElements.every(Boolean)) {
    uploadElements.forEach((element) => formCard.insertBefore(element, firstTextLabel));
    videoDrop.style.marginBottom = "18px";
  }
}
if (PM_AI_VIDEO_ENABLED && videoDrop) pmMountVideoModePicker(videoDrop);

function pmMountVideoModePicker(videoDrop) {
  const style = document.createElement("style");
  style.textContent = `
    #pmVideoMode{direction:rtl;display:grid;gap:12px;margin-top:4px}
    #pmVideoMode .pm-vm-sec{border:2px solid #d9dfe8;border-radius:16px;background:#fff;overflow:hidden;transition:border-color .15s,box-shadow .15s}
    #pmVideoMode .pm-vm-sec.open{border-color:#1FA25C;box-shadow:0 4px 14px rgba(31,162,92,.12)}
    #pmVideoMode .pm-vm-head{all:unset;box-sizing:border-box;width:100%;cursor:pointer;display:flex;align-items:center;gap:12px;padding:14px 14px;text-align:right}
    #pmVideoMode .pm-vm-radio{flex:none;width:20px;height:20px;border-radius:50%;border:2px solid #b9c2cf;position:relative}
    #pmVideoMode .open .pm-vm-radio{border-color:#1FA25C}
    #pmVideoMode .open .pm-vm-radio::after{content:"";position:absolute;inset:3px;border-radius:50%;background:#1FA25C}
    #pmVideoMode .pm-vm-htext{flex:1;color:#1E4F7C;font-weight:800;font-size:15.5px;line-height:1.35}
    #pmVideoMode .pm-vm-htext small{display:block;font-weight:500;font-size:12.5px;color:#5b5267;margin-top:3px}
    #pmVideoMode .pm-vm-badge{display:inline-block;vertical-align:middle;background:#EC1E79;color:#fff;font-size:11px;font-weight:700;border-radius:999px;padding:1px 8px;margin-inline-start:6px}
    #pmVideoMode .pm-vm-body{display:none;padding:0 14px 14px}
    #pmVideoMode .open .pm-vm-body{display:block}
    #pmVideoMode .pm-vm-label{font-weight:800;font-size:14px;color:#1E4F7C;margin:14px 0 8px}
    #pmAiTemplates{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
    #pmAiTemplates button{font-family:inherit;cursor:pointer;border:2px solid #d9dfe8;background:#fff;border-radius:14px;padding:10px 4px;
      text-align:center;color:#1E4F7C;font-weight:700;font-size:14px;line-height:1.3}
    #pmAiTemplates button small{display:block;font-weight:500;font-size:12px;color:#5b5267;margin-top:2px}
    #pmAiTemplates button.active{border-color:#1FA25C;background:#effaf3}
    #pmAiTemplates .pm-vm-emoji{display:block;font-size:24px;margin-bottom:2px}
    #pmAiNote{margin-top:10px;font-size:12.5px;color:#5b5267;line-height:1.5}
    #pmAiPreview{position:relative;width:min(230px,62%);margin:0 auto 12px;border-radius:16px;overflow:hidden;
      background:#1E4F7C;aspect-ratio:3/4;box-shadow:0 6px 18px rgba(30,79,124,.18)}
    #pmAiPreview video{width:100%;height:100%;object-fit:cover;display:block}
    #pmAiPreview .pm-vm-prev-tag{position:absolute;top:8px;right:8px;background:rgba(255,255,255,.92);color:#1E4F7C;
      font-size:11.5px;font-weight:700;border-radius:999px;padding:2px 9px}
    @media (max-width:420px){#pmAiTemplates{grid-template-columns:repeat(2,1fr)}}`;
  document.head.appendChild(style);

  const wrap = document.createElement("div");
  wrap.id = "pmVideoMode";
  wrap.innerHTML = `
    <div class="pm-vm-sec" data-sec="ai">
      <button type="button" class="pm-vm-head" data-mode="ai">
        <span class="pm-vm-radio"></span>
        <span class="pm-vm-htext">✨ תייצרו לי סרטון מהתמונה<span class="pm-vm-badge">חדש</span>
          <small>מעלים רק תמונה, ואנחנו מפיחים בה חיים</small></span>
      </button>
      <div class="pm-vm-body" data-body="ai">
        <div class="pm-vm-label">איזה קסם יקרה בסרטון?</div>
        <div id="pmAiPreview"><video muted playsinline loop autoplay preload="metadata"></video><span class="pm-vm-prev-tag"></span></div>
        <div id="pmAiTemplates">${PM_AI_TEMPLATES.map((t) =>
          `<button type="button" data-template="${t.id}"><span class="pm-vm-emoji">${t.emoji}</span>${t.title}<small>${t.hint}</small></button>`).join("")}
        </div>
        <div id="pmAiNote">הסרטון ייווצר מהתמונה שלכם אחרי ההזמנה, ותקבלו אותו במייל ✨</div>
      </div>
    </div>
    <div class="pm-vm-sec" data-sec="upload">
      <button type="button" class="pm-vm-head" data-mode="upload">
        <span class="pm-vm-radio"></span>
        <span class="pm-vm-htext">🎬 יש לי תמונה וסרטון
          <small>מעלים תמונה לפאזל וסרטון משלכם, עד 30 שניות</small></span>
      </button>
      <div class="pm-vm-body" data-body="upload"></div>
    </div>`;

  // Current layout: photo + video tiles side by side in .pm-tiles. The tiles move into whichever
  // section is open (AI: photo tile above the templates; own video: both tiles).
  const tiles = videoDrop.closest(".pm-tiles") || videoDrop.parentElement;
  tiles.insertAdjacentElement("beforebegin", wrap);
  const step = videoDrop.closest(".pm-step");
  const stepHead = step?.querySelector(".pm-step-head");
  const headText = stepHead ? [...stepHead.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim()) : null;
  if (headText) headText.textContent = " העלו תמונה ובחרו סרטון";
  const stepSub = step?.querySelector(".pm-step-sub");
  if (stepSub) stepSub.textContent = "יש שתי דרכים לסרטון שמתעורר כשסורקים את הפאזל, בחרו אחת";
  const aiBody = wrap.querySelector('[data-body="ai"]');
  const uploadBody = wrap.querySelector('[data-body="upload"]');
  const previewVideo = wrap.querySelector("#pmAiPreview video");
  const previewTag = wrap.querySelector("#pmAiPreview .pm-vm-prev-tag");

  const render = () => {
    wrap.querySelectorAll(".pm-vm-sec").forEach((sec) => sec.classList.toggle("open", sec.dataset.sec === pmVideoMode));
    wrap.querySelectorAll("[data-template]").forEach((b) => b.classList.toggle("active", b.dataset.template === pmVideoTemplate));
    const ai = pmVideoMode === "ai";
    if (ai) aiBody.insertBefore(tiles, aiBody.firstChild);
    else if (pmVideoMode === "upload") uploadBody.appendChild(tiles);
    tiles.style.display = pmVideoMode ? "" : "none";
    videoDrop.style.display = ai ? "none" : "";
    tiles.style.gridTemplateColumns = ai ? "1fr" : "";
    // Example clip for the selected template; loaded only once the AI section is opened.
    const sample = PM_AI_TEMPLATES.find((t) => t.id === pmVideoTemplate);
    if (ai && sample && previewVideo.dataset.template !== sample.id) {
      previewVideo.dataset.template = sample.id;
      previewVideo.src = sample.sample;
      previewTag.textContent = "דוגמה: " + sample.title;
      previewVideo.play().catch(() => {});
    }
  };
  // Switching sections collapses the one above, so the page shifts and the customer lands far
  // below the section they picked. Bring the newly opened section's head back to the top.
  const scrollToSection = (mode) => {
    const sec = wrap.querySelector(`.pm-vm-sec[data-sec="${mode}"]`);
    if (!sec) return;
    // The sticky header hides while scrolling down and slides back in on the way up, so always
    // leave room for it.
    const header = document.querySelector(".section-header");
    const headerOffset = header && /sticky|fixed/.test(getComputedStyle(header).position) ? header.offsetHeight : 0;
    const top = sec.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  };
  wrap.addEventListener("click", (event) => {
    const button = event.target.closest("button");
    if (!button) return;
    const prevMode = pmVideoMode;
    if (button.dataset.mode) pmVideoMode = button.dataset.mode;
    if (button.dataset.template) pmVideoTemplate = button.dataset.template;
    render();
    if (button.dataset.mode && prevMode && prevMode !== pmVideoMode) scrollToSection(pmVideoMode);
  });
  render();
}

// Keep the complete video frame visible in both the preview and native fullscreen.
// The original template uses a fixed square crop; override it here so portrait stays
// portrait and landscape stays landscape without changing the uploaded file.
const previewVideo = $("pmPreviewVid");
if (previewVideo) {
  previewVideo.style.height = "170px";
  previewVideo.style.maxHeight = "none";
  previewVideo.style.objectFit = "contain";
  previewVideo.style.objectPosition = "center";
}
const previewImage = $("pmPreviewImg");
if (previewImage) {
  previewImage.style.height = "170px";
  previewImage.style.objectFit = "contain";
  previewImage.style.objectPosition = "center";
}

// Keep the printed A6 greeting readable. At the card's 20px font size, 100
// characters fit the available message area without colliding with the sender
// or scan panel. Show the limit before typing and update it live.
const PM_MESSAGE_MAX = 100;
const messageInput = $("pmMessage");
if (messageInput) {
  messageInput.maxLength = PM_MESSAGE_MAX;
  messageInput.setAttribute("aria-describedby", "pmMessageCount");
  const counter = document.createElement("div");
  counter.id = "pmMessageCount";
  counter.style.cssText = "margin:-12px 4px 18px;color:#8a8170;font-size:12px;text-align:left;direction:rtl;";
  const updateMessageCount = () => {
    if (messageInput.value.length > PM_MESSAGE_MAX) {
      messageInput.value = messageInput.value.slice(0, PM_MESSAGE_MAX);
    }
    counter.textContent = messageInput.value.length + " מתוך " + PM_MESSAGE_MAX + " תווים";
    counter.style.color = messageInput.value.length >= PM_MESSAGE_MAX ? "#6d388b" : "#8a8170";
  };
  messageInput.style.marginBottom = "18px";
  messageInput.insertAdjacentElement("afterend", counter);
  messageInput.addEventListener("input", updateMessageCount);
  updateMessageCount();
}
const previewStyle = document.createElement("style");
previewStyle.textContent = `
  #pmPreviewVid:fullscreen,
  #pmPreviewVid:-webkit-full-screen {
    width: 100vw !important;
    height: 100vh !important;
    max-height: none !important;
    object-fit: contain !important;
    object-position: center !important;
    background: #000 !important;
  }
  @media (max-width: 600px) {
    #pmPreview > div { grid-template-columns: 1fr !important; }
    #pmPreviewImg, #pmPreviewVid { width: 100% !important; height: 220px !important; max-height: none !important; object-fit: contain !important; }
  }
`;
document.head.appendChild(previewStyle);
const previewReplaceHint = $("pmPreview")?.querySelector("p:last-child");
const uploadLauncher = $("pmFormWrap");

const open = () => {
  if (uploadDone && !personalAddedToCart) prepareUploadReplacement();
  overlay.style.display = "block";
  document.body.style.overflow = "hidden";
};
const close = () => { overlay.style.display = "none"; document.body.style.overflow = ""; };
$("pmOpenUpload").addEventListener("click", open);
$("pmCloseUpload").addEventListener("click", close);
overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });

let videoOk = false;
let uploadDone = false;
let personalAddedToCart = false;
let preparedUploadCode = null;
let preparedPieces = null;
let preparedHasVideo = false;
let imgURL = null, vidURL = null;
let imageUploadPromise = null, videoUploadPromise = null, boxUploadPromise = null;
let submitProgressVisible = false;
let submitProgressMessageTimer = null;
let croppedImageFile = null;
let cropOrientation = "portrait";
let cropSourceFile = null, cropSourceUrl = null, cropImageNaturalW = 0, cropImageNaturalH = 0;
let cropBaseScale = 1, cropZoom = 1, cropOffsetX = 0, cropOffsetY = 0;
let cropPointers = new Map(), cropLastCenter = null, cropLastDistance = 0;
let trimSelStart = 0, trimSelEnd = null;

function prepareUploadReplacement() {
  if (submitProgressMessageTimer) clearTimeout(submitProgressMessageTimer);
  submitProgressMessageTimer = null;
  submitProgressVisible = false;
  const progress = $("pmSubmitProgress");
  if (progress) progress.style.display = "none";
  uploadDone = false;
  preparedPieces = null;
  preparedUploadCode = null;
  preparedHasVideo = false;
  imageUploadPromise = null;
  videoUploadPromise = null;
  boxUploadPromise = null;
  setFactoryLineProperties({});
  $("pmFormWrap").style.display = "block";
  $("pmSuccessWrap").style.display = "none";
  const submit = $("pmSubmitUpload");
  submit.disabled = false;
  submit.style.opacity = "1";
  submit.innerHTML = "<span>✨</span> העלו תמונה וסרטון";
  if (previewReplaceHint) previewReplaceHint.style.display = "block";
}

async function hideReplacementAfterCartAdd(attempt = 0) {
  if (!preparedUploadCode || personalAddedToCart) return;
  try {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    const cart = response.ok ? await response.json() : null;
    const found = (cart?.items || []).some((item) =>
      String(item?.properties?.upload_code || "").toUpperCase() === preparedUploadCode
    );
    if (found) {
      personalAddedToCart = true;
      if (previewReplaceHint) previewReplaceHint.style.display = "none";
      if (uploadLauncher) uploadLauncher.style.display = "none";
      const sw = $("pmSuccessWrap");
      if (sw) { sw.style.display = "block"; }
      const st = $("pmSuccessTitle");
      if (st) st.textContent = preparedHasVideo ? "התמונה והסרטון נשמרו!" : "התמונה וקובצי ההדפסה נשמרו!";
      return;
    }
  } catch (_) { /* retry below */ }
  if (attempt < 9) setTimeout(() => hideReplacementAfterCartAdd(attempt + 1), 500);
}

function fmtTime(s) {
  s = Math.max(0, Math.round(s));
  return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
}

function startBackgroundUpload(file, type, onState) {
  onState("uploading");
  return uploadFile(file, type)
    .then((info) => { onState("done"); return { info }; })
    .catch((error) => { onState("failed"); return { error }; });
}

async function finishUpload(promise, file, type) {
  const result = promise ? await promise : null;
  if (result && result.info) return result.info;
  // Never fall back to the original source after a background preparation/upload failure.
  // For a long video that would bypass the 30-second trim and send the entire recording.
  if (result && result.error) throw result.error;
  return uploadFile(file, type);
}

function selectedPuzzlePieces() {
  const inputs = document.querySelectorAll('form[data-type="add-to-cart-form"] [name="id"], form[action*="/cart/add"] [name="id"]');
  for (const input of inputs) {
    const value = String(input.value || "");
    for (const [variantId, pieces] of Object.entries(PM_VARIANT_PIECES)) {
      if (value === variantId || value.endsWith("/" + variantId)) return pieces;
    }
  }
  const urlVariant = new URL(location.href).searchParams.get("variant");
  if (urlVariant && PM_VARIANT_PIECES[urlVariant]) return PM_VARIANT_PIECES[urlVariant];
  return null;
}

function showGateWarning(message) {
  const w = $("pmGateWarning");
  if (w) {
    w.textContent = message || "⚠️ יש להעלות תמונה לפני הוספה לעגלה";
    w.style.display = "block";
  }
  const btn = $("pmStep1");
  if (btn) {
    btn.classList.remove("pm-shake");
    void btn.offsetWidth;
    btn.classList.add("pm-shake");
    btn.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

function blockUnpreparedCart(e) {
  const selected = selectedPuzzlePieces();
  if (!uploadDone) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    showGateWarning();
    return true;
  }
  if (!selected || selected !== preparedPieces) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    showGateWarning("⚠️ מספר החלקים השתנה לאחר ההעלאה. החזירו לבחירה הקודמת או העלו מחדש את הקבצים.");
    return true;
  }
  return false;
}

document.addEventListener("submit", function (e) {
  if (e.target && e.target.matches && e.target.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) {
    if (!blockUnpreparedCart(e)) setTimeout(() => hideReplacementAfterCartAdd(), 500);
  }
}, true);
document.addEventListener("click", function (e) {
  const skipCartBtn = e.target.closest && e.target.closest("[data-skip-cart-button]");
  if (skipCartBtn && !blockUnpreparedCart(e)) setTimeout(() => hideReplacementAfterCartAdd(), 500);
}, true);
function showPreview() {
  $("pmPreview").style.display = (imgURL || vidURL) ? "block" : "none";
}

const cropOverlay = $("pmCropOverlay");
if (cropOverlay && cropOverlay.parentNode !== document.body) document.body.appendChild(cropOverlay);

function cropAspectForPieces(pieces) {
  const spec = PM_BOX_SPECS[pieces];
  const raw = spec && spec.puzzleSizeCm ? String(spec.puzzleSizeCm).split("x").map(Number) : [40, 28];
  // All puzzle print files are portrait. Product labels are not consistent about
  // whether the long side is written first, so normalize to short-side / long-side.
  return raw[0] > 0 && raw[1] > 0 ? Math.min(raw[0], raw[1]) / Math.max(raw[0], raw[1]) : 28 / 40;
}

function setPuzzleCropFrame(pieces, orientation, automatic) {
  cropOrientation = orientation === "landscape" ? "landscape" : "portrait";
  const portraitAspect = cropAspectForPieces(pieces);
  const viewport = $("pmCropViewport");
  viewport.style.aspectRatio = String(cropOrientation === "landscape" ? 1 / portraitAspect : portraitAspect);
  viewport.style.width = cropOrientation === "landscape" ? "min(400px,80vw)" : "auto";
  viewport.style.height = cropOrientation === "landscape" ? "auto" : "min(320px,42vh)";
  const portrait = $("pmCropPortrait"), landscape = $("pmCropLandscape");
  const active = "padding:9px 15px;border:2px solid #8b3ff0;border-radius:11px;background:#8b3ff0;color:#fff;font-weight:800;cursor:pointer;font-family:inherit;";
  const idle = "padding:9px 15px;border:2px solid #d9cde8;border-radius:11px;background:#fff;color:#665f73;font-weight:800;cursor:pointer;font-family:inherit;";
  portrait.style.cssText = cropOrientation === "portrait" ? active : idle;
  landscape.style.cssText = cropOrientation === "landscape" ? active : idle;
  $("pmCropOrientationNote").textContent = automatic
    ? "בחרנו אוטומטית " + (cropOrientation === "landscape" ? "פאזל לרוחב" : "פאזל לאורך") + " כדי לשמור יותר מהתמונה"
    : "בחרתם פאזל " + (cropOrientation === "landscape" ? "לרוחב" : "לאורך");
  $("pmCropOverlay").querySelector("h2").textContent = "התאימו את התמונה לפאזל";
  $("pmCropOverlay").querySelector("h2 + p").textContent = "החיתוך שתבחרו ישמש גם לפאזל וגם לקופסה. גררו ושנו זום עד שכל מה שחשוב נמצא במסגרת.";
  $("pmCropConfirm").textContent = "✓ אישור התמונה";
}

function bestCropOrientation(pieces) {
  const portraitAspect = cropAspectForPieces(pieces);
  const sourceAspect = cropImageNaturalW / cropImageNaturalH;
  const portraitLoss = Math.abs(Math.log(sourceAspect / portraitAspect));
  const landscapeLoss = Math.abs(Math.log(sourceAspect / (1 / portraitAspect)));
  return landscapeLoss < portraitLoss ? "landscape" : "portrait";
}

function cropViewportSize() {
  const viewport = $("pmCropViewport");
  return { width: viewport.clientWidth, height: viewport.clientHeight };
}

function clampCropOffsets() {
  const { width, height } = cropViewportSize();
  const displayW = cropImageNaturalW * cropBaseScale * cropZoom;
  const displayH = cropImageNaturalH * cropBaseScale * cropZoom;
  const maxX = Math.max(0, (displayW - width) / 2);
  const maxY = Math.max(0, (displayH - height) / 2);
  cropOffsetX = Math.max(-maxX, Math.min(maxX, cropOffsetX));
  cropOffsetY = Math.max(-maxY, Math.min(maxY, cropOffsetY));
}

function renderCropPosition() {
  const image = $("pmCropImage");
  const { width, height } = cropViewportSize();
  if (!width || !height || !cropImageNaturalW) return;
  clampCropOffsets();
  const displayW = cropImageNaturalW * cropBaseScale * cropZoom;
  const displayH = cropImageNaturalH * cropBaseScale * cropZoom;
  image.style.width = displayW + "px";
  image.style.height = displayH + "px";
  image.style.left = ((width - displayW) / 2 + cropOffsetX) + "px";
  image.style.top = ((height - displayH) / 2 + cropOffsetY) + "px";
  const sourceWidth = width / (cropBaseScale * cropZoom);
  const sourceHeight = height / (cropBaseScale * cropZoom);
  const quality = Math.min(sourceWidth / width, sourceHeight / height);
  $("pmCropQuality").textContent = quality < 1.25
    ? "⚠️ הזום גבוה ועלול להפחית את איכות ההדפסה"
    : "✓ איכות התמונה מתאימה למסגרת שנבחרה";
  $("pmCropQuality").style.color = quality < 1.25 ? "#b45309" : "#4f7d35";
}

function resetCropPosition() {
  const hint = $("pmCropHint");
  if (hint) hint.style.opacity = "1";
  const { width, height } = cropViewportSize();
  cropBaseScale = Math.max(width / cropImageNaturalW, height / cropImageNaturalH);
  cropZoom = 1;
  cropOffsetX = 0;
  cropOffsetY = 0;
  $("pmCropZoom").value = "1";
  renderCropPosition();
}

function openImageCrop(file) {
  const pieces = selectedPuzzlePieces();
  if (!pieces) {
    $("pmImageLabel").textContent = "בחרו מספר חלקים לפני העלאת תמונה";
    $("pmImage").value = "";
    showGateWarning("⚠️ בחרו מספר חלקים לפני העלאת התמונה");
    return;
  }
  cropSourceFile = file;
  croppedImageFile = null;
  imageUploadPromise = null;
  boxUploadPromise = null;
  if (cropSourceUrl) URL.revokeObjectURL(cropSourceUrl);
  cropSourceUrl = URL.createObjectURL(file);
  const image = $("pmCropImage");
  const viewport = $("pmCropViewport");
  image.onload = () => {
    cropImageNaturalW = image.naturalWidth;
    cropImageNaturalH = image.naturalHeight;
    setPuzzleCropFrame(pieces, bestCropOrientation(pieces), true);
    cropOverlay.style.display = "block";
    document.body.style.overflow = "hidden";
    requestAnimationFrame(resetCropPosition);
  };
  image.onerror = () => {
    $("pmImageLabel").textContent = "לא הצלחנו לקרוא את התמונה, נסו קובץ אחר";
    $("pmImage").value = "";
    URL.revokeObjectURL(cropSourceUrl);
    cropSourceUrl = null;
  };
  image.src = cropSourceUrl;
}

function closeImageCrop(clearSelection) {
  cropOverlay.style.display = "none";
  document.body.style.overflow = overlay.style.display === "block" ? "hidden" : "";
  cropPointers.clear();
  cropLastCenter = null;
  cropLastDistance = 0;
  if (clearSelection) {
    $("pmImage").value = "";
    cropSourceFile = null;
    croppedImageFile = null;
    boxUploadPromise = null;
      $("pmImageLabel").textContent = "לחצו להעלאת תמונה";
  }
  if (cropSourceUrl) { URL.revokeObjectURL(cropSourceUrl); cropSourceUrl = null; }
}

async function makeCroppedImageFile(suffix) {
  const viewport = $("pmCropViewport");
  const image = $("pmCropImage");
  const width = viewport.clientWidth, height = viewport.clientHeight;
  const displayW = cropImageNaturalW * cropBaseScale * cropZoom;
  const displayH = cropImageNaturalH * cropBaseScale * cropZoom;
  const left = (width - displayW) / 2 + cropOffsetX;
  const top = (height - displayH) / 2 + cropOffsetY;
  const sourceScale = cropBaseScale * cropZoom;
  const sx = Math.max(0, -left / sourceScale);
  const sy = Math.max(0, -top / sourceScale);
  const sw = Math.min(cropImageNaturalW - sx, width / sourceScale);
  const sh = Math.min(cropImageNaturalH - sy, height / sourceScale);
  const outW = Math.max(1, Math.min(4500, Math.round(sw)));
  const outH = Math.max(1, Math.round(outW / (width / height)));
  const canvas = document.createElement("canvas");
  canvas.width = outW;
  canvas.height = outH;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, sx, sy, sw, sh, 0, 0, outW, outH);
  const blob = await new Promise((resolve, reject) =>
    canvas.toBlob((b) => b ? resolve(b) : reject(new Error("יצירת התמונה החתוכה נכשלה")), "image/jpeg", 0.95)
  );
  const stem = String(cropSourceFile && cropSourceFile.name || "puzzle").replace(/.[^.]+$/, "");
  return new File([blob], stem + "-" + suffix + "-cropped.jpg", { type: "image/jpeg", lastModified: Date.now() });
}

async function acceptCroppedImage() {
  const confirmButton = $("pmCropConfirm");
  confirmButton.disabled = true;
  confirmButton.textContent = "⏳ מכין את התמונה...";
  try {
    const file = await makeCroppedImageFile("puzzle");
    croppedImageFile = file;
    closeImageCrop(false);
    if (imgURL) URL.revokeObjectURL(imgURL);
    imgURL = URL.createObjectURL(file);
    $("pmPreviewImg").src = imgURL;
    $("pmPreviewImgCell").style.display = "block";
    showPreview();
    const pieces = selectedPuzzlePieces();
    const orientation = cropOrientation;
    $("pmImageLabel").textContent = "⏳ מעלה את התמונה ומכין את הקופסה...";
    imageUploadPromise = startBackgroundUpload(file, "image", () => {});
    boxUploadPromise = createBoxArtworkFile(file, pieces, orientation)
      .then(async (boxFile) => ({
        info: await uploadFile(boxFile, "box"),
        boxFile,
        sourceFile: file,
        pieces,
        orientation,
      }))
      .catch((error) => ({ error, sourceFile: file, pieces, orientation }));
    Promise.all([imageUploadPromise, boxUploadPromise]).then(([imageResult, boxResult]) => {
      if (croppedImageFile !== file) return;
      $("pmImageLabel").textContent = imageResult.info && boxResult.info
        ? "✓ התמונה וקובץ הקופסה הועלו"
        : "⚠️ ההעלאה תושלם באישור";
    });
  } finally {
    confirmButton.disabled = false;
    confirmButton.textContent = "✓ אישור התמונה";
  }
}

$("pmCropZoom").addEventListener("input", function () {
  const hint = $("pmCropHint");
  if (hint) hint.style.opacity = "0";
  cropZoom = Number(this.value);
  renderCropPosition();
});
$("pmCropReset").addEventListener("click", resetCropPosition);
$("pmCropPortrait").addEventListener("click", () => {
  setPuzzleCropFrame(selectedPuzzlePieces(), "portrait", false);
  requestAnimationFrame(resetCropPosition);
});
$("pmCropLandscape").addEventListener("click", () => {
  setPuzzleCropFrame(selectedPuzzlePieces(), "landscape", false);
  requestAnimationFrame(resetCropPosition);
});
$("pmCropConfirm").addEventListener("click", () => acceptCroppedImage().catch((e) => {
  $("pmCropQuality").textContent = e.message || "יצירת התמונה נכשלה";
  $("pmCropQuality").style.color = "#c0392b";
}));
$("pmCropCancel").addEventListener("click", () => closeImageCrop(true));
$("pmCropClose").addEventListener("click", () => closeImageCrop(true));

const cropViewport = $("pmCropViewport");
cropViewport.addEventListener("wheel", (e) => {
  e.preventDefault();
  const hint = $("pmCropHint");
  if (hint) hint.style.opacity = "0";
  cropZoom = Math.max(1, Math.min(3, cropZoom * (e.deltaY > 0 ? 0.94 : 1.06)));
  $("pmCropZoom").value = String(cropZoom);
  renderCropPosition();
}, { passive: false });
cropViewport.addEventListener("pointerdown", (e) => {
  const hint = $("pmCropHint");
  if (hint) hint.style.opacity = "0";
  cropViewport.setPointerCapture(e.pointerId);
  cropPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
  cropViewport.style.cursor = "grabbing";
});
cropViewport.addEventListener("pointermove", (e) => {
  if (!cropPointers.has(e.pointerId)) return;
  cropPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
  const points = [...cropPointers.values()];
  const center = points.reduce((a, p) => ({ x: a.x + p.x / points.length, y: a.y + p.y / points.length }), { x: 0, y: 0 });
  if (cropLastCenter) {
    cropOffsetX += center.x - cropLastCenter.x;
    cropOffsetY += center.y - cropLastCenter.y;
  }
  if (points.length >= 2) {
    const distance = Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
    if (cropLastDistance > 0) cropZoom = Math.max(1, Math.min(3, cropZoom * distance / cropLastDistance));
    cropLastDistance = distance;
    $("pmCropZoom").value = String(cropZoom);
  }
  cropLastCenter = center;
  renderCropPosition();
});
function endCropPointer(e) {
  cropPointers.delete(e.pointerId);
  cropLastCenter = null;
  cropLastDistance = 0;
  cropViewport.style.cursor = cropPointers.size ? "grabbing" : "grab";
}
cropViewport.addEventListener("pointerup", endCropPointer);
cropViewport.addEventListener("pointercancel", endCropPointer);

$("pmImage").addEventListener("change", function () {
  const file = this.files[0];
  if (!file) return;
  openImageCrop(file);
});
function clearVideoPreview() {
  if (vidURL) { URL.revokeObjectURL(vidURL); vidURL = null; }
  $("pmPreviewVid").removeAttribute("src");
  $("pmPreviewVidCell").style.display = "none";
  showPreview();
}
let preparedVideoFile = null;

async function prepareVideoUploadFile(file) {
  // Preserve the customer's original bytes, codecs and audio tracks. The selected 30-second
  // window is stored as metadata and enforced by the scanner instead of remuxing on the phone.
  return file;

  const needsTrim = trimSelEnd != null && trimDuration > 30.5;
  if (!needsTrim) return file;

  setSubmitProgress(1, "מכין את קטע הסרטון 1%");
  // Let the browser paint the initial state before packet reading begins.
  await new Promise((resolve) => requestAnimationFrame(resolve));

  const {
    ALL_FORMATS, BlobSource, BufferTarget, EncodedAudioPacketSource,
    EncodedPacketSink, EncodedVideoPacketSource, Input, Mp4OutputFormat, Output,
  } = await import("https://esm.sh/mediabunny@1?bundle");
  const input = new Input({ source: new BlobSource(file), formats: ALL_FORMATS });
  const videoTrack = await input.getPrimaryVideoTrack();
  if (!videoTrack) throw new Error("לא נמצאה רצועת וידאו");

  const videoSink = new EncodedPacketSink(videoTrack);
  const firstVideoPacket = await videoSink.getKeyPacket(trimSelStart, { verifyKeyPackets: true });
  if (!firstVideoPacket) throw new Error("לא נמצאה נקודת חיתוך תקינה בסרטון");

  // Packet-copy trimming must begin on a key frame. This is normally only a fraction of a
  // second before the customer's selection and avoids decoding, resizing and re-encoding.
  const actualStart = firstVideoPacket.timestamp;
  const actualEnd = Math.min(trimDuration, actualStart + 30);
  const endVideoPacket = await videoSink.getPacket(actualEnd, { metadataOnly: true });
  const target = new BufferTarget();
  const output = new Output({
    format: new Mp4OutputFormat({ fastStart: "in-memory" }),
    target,
  });

  const videoCodec = await videoTrack.getCodec();
  const videoConfig = await videoTrack.getDecoderConfig();
  const videoSource = new EncodedVideoPacketSource(videoCodec);
  output.addVideoTrack(videoSource, { rotation: await videoTrack.getRotation() });

  // Some phone containers do not mark their only audio track as the global "primary" track.
  // Prefer audio explicitly paired with the selected video, then fall back to any audio track.
  const allAudioTracks = await input.getAudioTracks();
  const audioTrack =
    await videoTrack.getPrimaryPairableAudioTrack() ||
    await input.getPrimaryAudioTrack() ||
    allAudioTracks[0] ||
    null;
  let audioSource = null;
  let audioSink = null;
  let firstAudioPacket = null;
  let endAudioPacket = null;
  let audioConfig = null;
  if (audioTrack) {
    audioSink = new EncodedPacketSink(audioTrack);
    firstAudioPacket = await audioSink.getPacket(actualStart);
    endAudioPacket = await audioSink.getPacket(actualEnd, { metadataOnly: true });
    audioConfig = await audioTrack.getDecoderConfig();
    audioSource = new EncodedAudioPacketSource(await audioTrack.getCodec());
    output.addAudioTrack(audioSource);
  }

  const collectPackets = async (sink, firstPacket, endPacket, reportProgress) => {
    if (!firstPacket) return [];
    const packets = [];
    let displayedPercent = 1;
    let lastPaintedPercent = 1;
    for await (const packet of sink.packets(firstPacket, endPacket)) {
      packets.push(packet);
      if (reportProgress) {
        const ratio = Math.max(0, Math.min(1, (packet.timestamp - actualStart) / Math.max(0.1, actualEnd - actualStart)));
        const percent = Math.max(displayedPercent, Math.max(1, Math.min(100, Math.round(ratio * 100))));
        displayedPercent = percent;
        $("pmVideoLabel").textContent = "⏳ חותך את הסרטון " + percent + "%";
        setSubmitProgress(percent, "חותך את הסרטון " + percent + "%");
        // Packet iteration can otherwise finish in one long browser task, making the UI
        // appear to jump directly from its previous value to 100%. Yield only for display.
        if (percent >= lastPaintedPercent + 5) {
          lastPaintedPercent = percent;
          await new Promise((resolve) => requestAnimationFrame(resolve));
        }
      }
    }
    return packets;
  };
  const [videoPackets, audioPackets] = await Promise.all([
    collectPackets(videoSink, firstVideoPacket, endVideoPacket, true),
    audioSource ? collectPackets(audioSink, firstAudioPacket, endAudioPacket, false) : Promise.resolve([]),
  ]);
  if (!videoPackets.length) throw new Error("לא נמצאו פריימים בקטע שנבחר");

  $("pmVideoLabel").textContent = "⏳ חותך את הסרטון 100%";
  setSubmitProgress(100, "חותך את הסרטון 100%");
  await new Promise((resolve) => requestAnimationFrame(resolve));

  // B-frames in iPhone MOV/HEVC files may have presentation timestamps just before the
  // selected key frame. Shift from the earliest packet so the MP4 muxer never receives
  // a negative timestamp while decode order and original quality remain unchanged.
  const timelineStart = Math.min(...videoPackets.map((packet) => packet.timestamp), ...audioPackets.map((packet) => packet.timestamp));
  $("pmVideoLabel").textContent = "⏳ החיתוך הושלם — מסיים להכין את הקובץ...";
  setSubmitProgress(100, "החיתוך הושלם — מסיים להכין את הקובץ...");

  await output.start();
  const copyPackets = async (packets, source, decoderConfig) => {
    if (!packets.length) { source.close(); return; }
    let isFirst = true;
    for (const packet of packets) {
      const shifted = packet.clone({ timestamp: packet.timestamp - timelineStart });
      await source.add(shifted, isFirst ? { decoderConfig } : undefined);
      isFirst = false;
    }
    source.close();
  };
  await Promise.all([
    copyPackets(videoPackets, videoSource, videoConfig),
    audioSource ? copyPackets(audioPackets, audioSource, audioConfig) : Promise.resolve(),
  ]);
  await output.finalize();
  if (!target.buffer) throw new Error("חיתוך הסרטון נכשל");
  // Never silently turn a video that had sound into a video-only file. This validates the
  // actual muxed result before it is uploaded and before the customer can reach checkout.
  if (audioTrack) {
    const outputCheck = new Input({ source: new BlobSource(new Blob([target.buffer])), formats: ALL_FORMATS });
    const outputAudioTracks = await outputCheck.getAudioTracks();
    outputCheck.dispose();
    if (outputAudioTracks.length === 0) {
      throw new Error("שמירת הסאונד בחיתוך נכשלה — נסו סרטון אחר או קטע קצר מ־30 שניות");
    }
  }
  if (target.buffer.byteLength > 100 * 1024 * 1024) {
    throw new Error("קטע הסרטון בן 30 השניות עדיין גדול מ־100 מגה");
  }
  setSubmitProgress(100, "100% — קטע הסרטון מוכן ומתחיל לעלות...");

  // The uploaded file is now the clip itself, so downstream playback must start at zero.
  trimSelStart = 0;
  trimSelEnd = actualEnd - timelineStart;
  return new File([target.buffer], "puzzlemagic-video.mp4", { type: "video/mp4", lastModified: Date.now() });
}

function acceptVideo(f) {
  videoOk = true;
  $("pmVideoLabel").textContent = "✓ " + f.name;
  if (vidURL) URL.revokeObjectURL(vidURL);
  vidURL = URL.createObjectURL(f);
  $("pmPreviewVid").src = vidURL;
  $("pmPreviewVidCell").style.display = "block";
  showPreview();
  preparedVideoFile = null;
  videoUploadPromise = (async () => {
    try {
      $("pmVideoLabel").textContent = "⏳ מכין את הסרטון...";
      preparedVideoFile = await prepareVideoUploadFile(f);
      if ($("pmVideo").files[0] !== f) throw new Error("הסרטון הוחלף");
      $("pmVideoLabel").textContent = "⏳ מעלה את הסרטון...";
      const info = await uploadFile(preparedVideoFile, "video");
      $("pmVideoLabel").textContent = "✓ הסרטון הועלה";
      return { info };
    } catch (error) {
      console.error("PuzzleMagic video preparation/upload failed", error);
      preparedVideoFile = null;
      if ($("pmVideo").files[0] === f) {
        const reason = error && error.message ? ": " + error.message : "";
        $("pmVideoLabel").textContent = "⚠️ הכנת הסרטון נכשלה" + reason;
      }
      return { error };
    }
  })();
}

// --- Trim step: shown only when the picked video is longer than the 30s limit ---
let trimFile = null, trimDuration = 0, trimWindowLen = 30, trimPreviewURL = null, trimDragging = false, trimDragOffset = 0;

function trimSetLabels() {
  $("pmTrimSelLabel").textContent = fmtTime(trimSelStart) + "–" + fmtTime(trimSelStart + trimWindowLen);
  $("pmTrimTotalLabel").textContent = "מתוך " + fmtTime(trimDuration);
}

function trimLayout() {
  const track = $("pmTrimTrack");
  const w = track.clientWidth;
  if (!w) return;
  const winW = Math.max(24, (trimWindowLen / trimDuration) * w);
  const leftPx = Math.max(0, Math.min(w - winW, (trimSelStart / trimDuration) * w));
  $("pmTrimWindow").style.left = leftPx + "px";
  $("pmTrimWindow").style.width = winW + "px";
  $("pmTrimDimL").style.width = leftPx + "px";
  $("pmTrimDimR").style.width = Math.max(0, w - leftPx - winW) + "px";
}

function openTrim(file, url, duration) {
  trimFile = file;
  trimDuration = duration;
  trimWindowLen = Math.min(30, duration);
  trimSelStart = 0;
  trimSelEnd = trimWindowLen;
  trimPreviewURL = url;

  const v = $("pmTrimVideo");
  v.src = url;
  v.onloadedmetadata = () => { v.currentTime = trimSelStart; v.play().catch(() => {}); };
  v.ontimeupdate = () => {
    if (v.currentTime >= trimSelStart + trimWindowLen) v.currentTime = trimSelStart;
  };

  trimSetLabels();
  trimOverlay.style.display = "block";
  document.body.style.overflow = "hidden";
  requestAnimationFrame(trimLayout);
}

function closeTrim(revokePreview) {
  const v = $("pmTrimVideo");
  v.pause();
  v.onloadedmetadata = null;
  v.ontimeupdate = null;
  v.removeAttribute("src");
  trimOverlay.style.display = "none";
  document.body.style.overflow = overlay.style.display === "block" ? "hidden" : "";
  if (revokePreview && trimPreviewURL) { URL.revokeObjectURL(trimPreviewURL); trimPreviewURL = null; }
}

const trimWindowEl = $("pmTrimWindow");
trimWindowEl.addEventListener("pointerdown", (e) => {
  e.preventDefault();
  trimDragging = true;
  trimWindowEl.setPointerCapture(e.pointerId);
  trimDragOffset = e.clientX - trimWindowEl.getBoundingClientRect().left;
  trimWindowEl.style.cursor = "grabbing";
});
trimWindowEl.addEventListener("pointermove", (e) => {
  if (!trimDragging) return;
  const track = $("pmTrimTrack");
  const rect = track.getBoundingClientRect();
  const w = rect.width;
  const winW = (trimWindowLen / trimDuration) * w;
  let leftPx = e.clientX - rect.left - trimDragOffset;
  leftPx = Math.max(0, Math.min(w - winW, leftPx));
  trimSelStart = (leftPx / w) * trimDuration;
  trimWindowEl.style.left = leftPx + "px";
  $("pmTrimDimL").style.width = leftPx + "px";
  $("pmTrimDimR").style.width = Math.max(0, w - leftPx - winW) + "px";
  trimSetLabels();
});
function endTrimDrag() {
  if (!trimDragging) return;
  trimDragging = false;
  trimWindowEl.style.cursor = "grab";
  trimSelEnd = trimSelStart + trimWindowLen;
  const v = $("pmTrimVideo");
  if (v.readyState >= 1) v.currentTime = trimSelStart;
}
trimWindowEl.addEventListener("pointerup", endTrimDrag);
trimWindowEl.addEventListener("pointercancel", endTrimDrag);
window.addEventListener("resize", () => { if (trimOverlay.style.display === "block") trimLayout(); });

$("pmTrimConfirm").addEventListener("click", () => {
  trimSelEnd = trimSelStart + trimWindowLen;
  closeTrim(false);
  acceptVideo(trimFile);
});
function cancelTrim() {
  closeTrim(true);
  $("pmVideo").value = "";
  preparedVideoFile = null;
  videoUploadPromise = null;
  clearVideoPreview();
}
$("pmTrimCancel").addEventListener("click", cancelTrim);
$("pmTrimClose").addEventListener("click", cancelTrim);

$("pmVideo").addEventListener("change", function () {
  const f = this.files[0]; if (!f) return;
  videoOk = false;
  trimSelStart = 0; trimSelEnd = null;
  // The original file is uploaded unchanged, so enforce the actual Storage limit up front.
  if (f.size > 100 * 1024 * 1024) { $("pmVideoLabel").textContent = "הסרטון כבד מדי (מקסימום 100 מגה)"; this.value = ""; clearVideoPreview(); return; }
  const url = URL.createObjectURL(f);
  const probe = document.createElement("video");
  probe.preload = "metadata";
  probe.onloadedmetadata = () => {
    if (probe.duration > 30.5) {
      openTrim(f, url, probe.duration);
    } else {
      URL.revokeObjectURL(url);
      acceptVideo(f);
    }
  };
  probe.onerror = () => { $("pmVideoLabel").textContent = "לא הצלחנו לקרוא את הסרטון, נסו קובץ אחר"; $("pmVideo").value = ""; URL.revokeObjectURL(url); clearVideoPreview(); };
  probe.src = url;
});

function setupFileDropZone(zoneId, inputId, expectedKind) {
  const zone = $(zoneId);
  const input = $(inputId);
  if (!zone || !input) return;
  const normalBorder = zone.style.borderColor || "#d9cdb2";
  const normalBackground = zone.style.background || "transparent";
  const setDragging = (active) => {
    zone.style.borderColor = active ? "#6d388b" : normalBorder;
    zone.style.background = active ? "#f4ecff" : normalBackground;
    zone.style.color = active ? "#6d388b" : "#8a8170";
  };
  for (const eventName of ["dragenter", "dragover"]) {
    zone.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
      setDragging(true);
    });
  }
  for (const eventName of ["dragleave", "dragend"]) {
    zone.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();
      setDragging(false);
    });
  }
  zone.addEventListener("drop", (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
    const files = Array.from(event.dataTransfer?.files || []);
    const file = files.find((candidate) => candidate.type.startsWith(expectedKind + "/"));
    if (!file) {
      $(expectedKind === "image" ? "pmImageLabel" : "pmVideoLabel").textContent =
        expectedKind === "image" ? "נא לגרור קובץ תמונה" : "נא לגרור קובץ סרטון";
      return;
    }
    const transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
}

setupFileDropZone("pmImageDrop", "pmImage", "image");
setupFileDropZone("pmVideoDrop", "pmVideo", "video");
if ($("pmImageLabel")?.textContent === "לחצו להעלאת תמונה") {
  $("pmImageLabel").textContent = "לחצו או גררו לכאן תמונה";
}
if ($("pmVideoLabel")?.textContent === "לחצו להעלאת סרטון") {
  $("pmVideoLabel").textContent = "לחצו או גררו לכאן סרטון";
}

function loadPmImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("טעינת תבנית הקופסה נכשלה"));
    image.src = src;
  });
}

function pmContentBounds(image) {
  const maxSize = 256;
  const ratio = Math.min(1, maxSize / image.naturalWidth, maxSize / image.naturalHeight);
  const width = Math.max(1, Math.round(image.naturalWidth * ratio));
  const height = Math.max(1, Math.round(image.naturalHeight * ratio));
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  if (!ctx) return [0, 0, image.naturalWidth, image.naturalHeight];
  ctx.drawImage(image, 0, 0, width, height);
  let pixels;
  try { pixels = ctx.getImageData(0, 0, width, height).data; }
  catch (_) { return [0, 0, image.naturalWidth, image.naturalHeight]; }
  const isContent = (x, y) => {
    const i = (y * width + x) * 4;
    if (pixels[i + 3] < 20) return false;
    return pixels[i] < 244 || pixels[i + 1] < 244 || pixels[i + 2] < 244;
  };
  const columnHasContent = (x) => {
    let count = 0;
    for (let y = 0; y < height; y += 1) if (isContent(x, y)) count += 1;
    return count >= Math.max(2, Math.round(height * 0.04));
  };
  const rowHasContent = (y) => {
    let count = 0;
    for (let x = 0; x < width; x += 1) if (isContent(x, y)) count += 1;
    return count >= Math.max(2, Math.round(width * 0.04));
  };
  let left = 0, right = width - 1, top = 0, bottom = height - 1;
  while (left < right && !columnHasContent(left)) left += 1;
  while (right > left && !columnHasContent(right)) right -= 1;
  while (top < bottom && !rowHasContent(top)) top += 1;
  while (bottom > top && !rowHasContent(bottom)) bottom -= 1;
  if (right - left + 1 < width * 0.35 || bottom - top + 1 < height * 0.35) {
    return [0, 0, image.naturalWidth, image.naturalHeight];
  }
  const scaleX = image.naturalWidth / width;
  const scaleY = image.naturalHeight / height;
  return [left * scaleX, top * scaleY, (right - left + 1) * scaleX, (bottom - top + 1) * scaleY];
}

function pmDrawCover(ctx, image, rect) {
  const [x1, y1, x2, y2] = rect;
  const width = x2 - x1, height = y2 - y1;
  const imageWidth = image.naturalWidth || image.width;
  const imageHeight = image.naturalHeight || image.height;
  // The puzzle crop is the source of truth. Fill the box window from that same image and
  // crop only the small ratio difference symmetrically — no blurred or padded side bands.
  const scale = Math.max(width / imageWidth, height / imageHeight);
  const sourceWidth = width / scale;
  const sourceHeight = height / scale;
  const sourceX = (imageWidth - sourceWidth) / 2;
  const sourceY = (imageHeight - sourceHeight) / 2;
  ctx.drawImage(image, sourceX, sourceY, sourceWidth, sourceHeight, x1, y1, width, height);
}

function pmExpandRect(rect, amount, rightAmount) {
  const [x1, y1, x2, y2] = rect;
  return [x1 - amount, y1 - amount, x2 + (rightAmount == null ? amount : rightAmount), y2 + amount];
}

function pmNormalizeCircularRegion(ctx, overlayImage, rect) {
  const [x1, y1, x2, y2] = rect;
  const sourceWidth = x2 - x1, sourceHeight = y2 - y1;
  const size = Math.max(sourceWidth, sourceHeight);
  const centerX = (x1 + x2) / 2, centerY = (y1 + y2) / 2;
  const targetX = centerX - size / 2, targetY = centerY - size / 2;
  ctx.save();
  ctx.beginPath();
  ctx.arc(centerX, centerY, size / 2, 0, Math.PI * 2);
  ctx.clip();
  ctx.drawImage(overlayImage, x1, y1, sourceWidth, sourceHeight, targetX, targetY, size, size);
  ctx.restore();
}

function pmDrawBadge(ctx, overlayImage, rect, options) {
  options = options || {};
  const [x1, y1, x2, y2] = rect;
  const sourceWidth = x2 - x1, sourceHeight = y2 - y1;
  const centerX = (x1 + x2) / 2, centerY = (y1 + y2) / 2;
  const scale = options.scale || 1;
  const squareSize = Math.max(sourceWidth, sourceHeight) * scale;
  const targetWidth = options.square ? squareSize : sourceWidth * scale;
  const targetHeight = options.square ? squareSize : sourceHeight * scale;
  const targetX = centerX - targetWidth / 2;
  const targetY = centerY - targetHeight / 2 + (options.offsetY || 0);
  const targetCenterY = targetY + targetHeight / 2;
  const radius = Math.min(targetWidth, targetHeight) / 2;
  const drawBadgeSource = () => ctx.drawImage(
    overlayImage,
    x1, y1, sourceWidth, sourceHeight,
    targetX, targetY, targetWidth, targetHeight,
  );
  // Portrait templates already contain the approved complete badge. Restore it
  // as-is after the customer photo is drawn; never add a second ring there.
  if (!options.recreateGoldRing) {
    const portraitRadius = radius * 0.92;
    ctx.save();
    ctx.beginPath();
    ctx.arc(centerX, targetCenterY, portraitRadius, 0, Math.PI * 2);
    ctx.clip();
    drawBadgeSource();
    ctx.restore();
    return;
  }
  // The source artwork has a pale halo outside its original rim. Composite
  // only the clean navy badge, then recreate a uniform gold ring so it matches
  // the three navy-and-gold icons on the left side of the box.
  const outerRadius = radius - Math.max(2.5, radius * 0.025);
  const ringWidth = (options.solidGoldRing ? Math.max(5, radius * 0.035) : Math.max(4, radius * 0.052)) * (options.ringScale || 1);
  const innerRadius = outerRadius - ringWidth;
  ctx.save();
  ctx.beginPath();
  ctx.arc(centerX, targetCenterY, innerRadius + 0.75, 0, Math.PI * 2);
  ctx.clip();
  drawBadgeSource();
  ctx.restore();

  let ring = "#d8a447";
  if (!options.solidGoldRing) {
    ring = ctx.createRadialGradient(centerX, targetCenterY, innerRadius, centerX, targetCenterY, outerRadius);
    ring.addColorStop(0, "#af7c41");
    ring.addColorStop(0.52, "#f09a43");
    ring.addColorStop(1, "#f8dbb3");
  }
  ctx.save();
  ctx.beginPath();
  ctx.arc(centerX, targetCenterY, outerRadius - ringWidth / 2, 0, Math.PI * 2);
  ctx.strokeStyle = ring;
  ctx.lineWidth = ringWidth;
  ctx.stroke();
  ctx.restore();
}

function pmCanvasBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => blob ? resolve(blob) : reject(new Error("יצירת קובץ הקופסה נכשלה")),
      "image/jpeg",
      1
    );
  });
}

async function createBoxArtworkFile(customerFile, pieces, orientation) {
  const spec = PM_BOX_SPECS[pieces];
  if (!spec) throw new Error("מספר החלקים אינו נתמך");
  const isLandscape = orientation === "landscape";
  const emptyAsset = isLandscape ? spec.landscapeEmpty : spec.empty;
  const overlayAsset = isLandscape ? spec.landscapeOverlay : spec.overlay;
  const photoRect = isLandscape ? spec.landscapePhoto : spec.photo;
  const badgeRect = isLandscape ? spec.landscapeBadge : spec.badge;
  const customerUrl = URL.createObjectURL(customerFile);
  try {
    const [empty, overlayImage, customerImage] = await Promise.all([
      loadPmImage(emptyAsset), loadPmImage(overlayAsset), loadPmImage(customerUrl),
    ]);
    const canvas = document.createElement("canvas");
    canvas.width = empty.naturalWidth;
    canvas.height = empty.naturalHeight;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("הדפדפן אינו תומך ביצירת קובץ הקופסה");
    ctx.drawImage(empty, 0, 0, canvas.width, canvas.height);
    ctx.drawImage(overlayImage, 0, 0, canvas.width, canvas.height);
    const photoBleed = isLandscape ? Math.round(Math.min(canvas.width, canvas.height) * 0.008) : 0;
    // 150 landscape's right window border is narrower, so a full bleed would bury the
    // gold line. Use ~0.7 so the photo fills up to the border yet leaves it visible,
    // matching the thin gold line on the left edge.
    const rightBleed = isLandscape && pieces === 150 ? Math.round(photoBleed * 0.7) : photoBleed;
    pmDrawCover(ctx, customerImage, photoBleed ? pmExpandRect(photoRect, photoBleed, rightBleed) : photoRect);
    if (isLandscape) {
      spec.landscapeSideIcons.forEach((iconRect) => pmNormalizeCircularRegion(ctx, overlayImage, iconRect));
    }
    pmDrawBadge(ctx, overlayImage, badgeRect, {
      recreateGoldRing: isLandscape || pieces === 300,
      square: isLandscape,
      scale: !isLandscape && pieces === 150 ? 1.1 : 1,
      offsetY: isLandscape ? Math.round(Math.max(badgeRect[2] - badgeRect[0], badgeRect[3] - badgeRect[1]) * 0.04) : 0,
      solidGoldRing: pieces === 300,
      ringScale: !isLandscape && pieces === 300 ? 0.6 : 1,
    });
    const blob = await pmCanvasBlob(canvas);
    return new File([blob], "box-" + spec.boxSizeCm.replaceAll(".", "-") + "-" + orientation + ".jpg", { type: "image/jpeg" });
  } finally {
    URL.revokeObjectURL(customerUrl);
  }
}

function setFactoryLineProperties(values) {
  const forms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  forms.forEach((form) => {
    form.querySelectorAll('input[data-pm-factory-property="true"]').forEach((input) => input.remove());
    Object.entries(values).forEach(([name, value]) => {
      if (!value) return;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[" + name + "]";
      input.value = String(value);
      input.dataset.pmFactoryProperty = "true";
      form.appendChild(input);
    });
  });
}

async function callFn(path, body) {
  const r = await fetch(FN + "/" + path, {
    method: "POST",
    headers: { "Content-Type": "application/json", apikey: ANON, Authorization: "Bearer " + ANON },
    body: JSON.stringify(body),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data && data.error ? data.error : "HTTP " + r.status);
  return data;
}

function pmWithTimeout(promise, ms) {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => {
      const error = new Error("timeout");
      error.code = "PM_UPLOAD_TIMEOUT";
      reject(error);
    }, ms)),
  ]);
}

function pmUploadTimeout(file) {
  // Mobile upload speeds can be far below download speeds. Give the original in-flight
  // request enough time instead of timing it out after 40s and starting duplicate uploads.
  // The allowance is based on a conservative 50 KB/s, with a 2-minute minimum.
  const estimated = Math.ceil((Number(file && file.size) || 0) / 50000) * 1000;
  return Math.min(10 * 60 * 1000, Math.max(2 * 60 * 1000, estimated));
}

// Retry genuine network/server failures. A timeout does not abort Supabase's underlying
// request, so retrying it would upload the same large file again in parallel on mobile.
async function uploadFile(file, type, uploadCode) {
  let lastErr;
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const init = await pmWithTimeout(
        callFn("customer-upload-init", { type, filename: file.name, upload_code: uploadCode || null }),
        15000,
      );
      const { error } = await pmWithTimeout(
        supabase.storage.from(init.bucket).uploadToSignedUrl(init.path, init.token, file, { upsert: true }),
        pmUploadTimeout(file),
      );
      if (error) throw error;
      return { bucket: init.bucket, path: init.path };
    } catch (e) {
      lastErr = e;
      if (e && e.code === "PM_UPLOAD_TIMEOUT") break;
    }
  }
  throw lastErr;
}

async function finishBoxUpload(promise, sourceFile, pieces, orientation) {
  const result = promise ? await promise : null;
  if (
    result && result.info && result.boxFile &&
    result.sourceFile === sourceFile &&
    result.pieces === pieces &&
    result.orientation === orientation
  ) return result;
  const boxFile = await createBoxArtworkFile(sourceFile, pieces, orientation);
  const info = await uploadFile(boxFile, "box");
  return { info, boxFile, sourceFile, pieces, orientation };
}

function setSubmitProgress(percent, label, failed) {
  // Preparation and background upload begin as soon as files are selected, but the customer
  // should only see order-submission progress after explicitly clicking Add to cart.
  if (!submitProgressVisible) return;
  let wrap = $("pmSubmitProgress");
  if (!wrap) {
    wrap = document.createElement("div");
    wrap.id = "pmSubmitProgress";
    wrap.style.cssText = "margin-top:12px;text-align:right;direction:rtl;font-size:13px;font-weight:700;color:#5b5267;";
    wrap.innerHTML = '<div id="pmSubmitProgressLabel"></div>';
    $("pmSubmitUpload").insertAdjacentElement("afterend", wrap);
  }
  wrap.style.display = "block";
  $("pmSubmitProgressLabel").textContent = label;
  $("pmSubmitProgressLabel").style.color = failed ? "#b42318" : "#5b5267";
}

$("pmSubmitUpload").addEventListener("click", async function () {
  const err = $("pmError"); err.style.display = "none";
  const name = $("pmName").value.trim();
  const img = croppedImageFile;
  const aiVideo = pmVideoMode === "ai";
  const vid = aiVideo ? null : $("pmVideo").files[0];
  // The customer's name and reveal video are optional; only the printable photo is required.
  if (!pmVideoMode) { err.textContent = "בחרו איך ייווצר הסרטון והעלו תמונה"; err.style.display = "block"; return; }
  if (!img) { err.textContent = "נא להעלות תמונה ולאשר את החיתוך לפאזל"; err.style.display = "block"; return; }
  if (vid && !videoOk) { err.textContent = "הסרטון שנבחר לא תקין"; err.style.display = "block"; return; }

  submitProgressVisible = true;
  setSubmitProgress(1, "מתחיל להוסיף את הפאזל לעגלה...");
  await new Promise((resolve) => requestAnimationFrame(resolve));
  const btn = this; btn.disabled = true; btn.style.opacity = ".7"; btn.innerHTML = "⏳ מעלה...";
  setSubmitProgress(8, "מכין את הקבצים להעלאה...");
  if (submitProgressMessageTimer) clearTimeout(submitProgressMessageTimer);
  submitProgressMessageTimer = setTimeout(() => {
    const label = $("pmSubmitProgressLabel");
    if (submitProgressVisible && label) label.textContent = "כמעט סיימנו — משלימים את שמירת הקבצים...";
  }, 3500);
  try {
    const pieces = selectedPuzzlePieces();
    const spec = PM_BOX_SPECS[pieces];
    if (!spec) throw new Error("בחרו מספר חלקים לפני ההעלאה");
    const imageTask = finishUpload(imageUploadPromise, img, "image");
    const videoTask = vid ? finishUpload(videoUploadPromise, preparedVideoFile || vid, "video") : Promise.resolve(null);
    const boxTask = finishBoxUpload(boxUploadPromise, img, pieces, cropOrientation);
    let completedUploads = 0;
    const totalUploads = vid ? 3 : 2;
    const trackUpload = (promise, label) => promise.then((value) => {
      completedUploads += 1;
      setSubmitProgress(10 + Math.round((completedUploads / totalUploads) * 70), label + " הושלם");
      return value;
    });
    const [imageInfo, videoInfo, boxResult] = await Promise.all([
      trackUpload(imageTask, "העלאת התמונה"),
      vid ? trackUpload(videoTask, "העלאת הסרטון") : videoTask,
      trackUpload(boxTask, "העלאת קובץ הקופסה"),
    ]);
    setSubmitProgress(85, "שומר את פרטי הפאזל...");
    const res = await callFn("customer-upload-finalize", {
      customer_name: name || "לקוח",
      customer_email: "pending@puzzlemagic.app",
      recipient_name: $("pmRecipient").value.trim() || null,
      message: $("pmMessage").value.trim() || null,
      image: imageInfo,
      video: videoInfo,
      box: boxResult.info,
      puzzle_piece_count: pieces,
      video_trim_start: vid ? trimSelStart : 0,
      video_trim_end: vid ? trimSelEnd : null,
      ...(aiVideo ? { video_source: "ai", video_template: pmVideoTemplate } : {}),
    });
    const cardRecipient = $("pmRecipient").value.trim();
    const cardMessage = $("pmMessage").value.trim();

    // Do not add the item to the cart until the complete factory ZIP exists. Navigating to the
    // cart or checkout aborts page-owned background work, which can otherwise leave a paid order
    // with only the base metadata and no print-file link.
    const baseProperties = {
      upload_code: res.upload_code,
      "_Factory - Product": "Personal Photo Puzzle",
      "_Factory - Pieces": String(res.puzzle_piece_count),
      "_Factory - Puzzle size": pmOrientedSize(res.puzzle_size_cm, cropOrientation) + " cm",
      "_Factory - Box size": pmOrientedSize(res.box_size_cm, cropOrientation) + " cm",
      "_Factory - Orientation": cropOrientation === "landscape" ? "HORIZONTAL" : "VERTICAL",
      // AI mode: the order confirmation email builds the customer's my-video link from this code.
      ...(aiVideo ? { _pm_ai_video: String(res.scan_code || "") } : {}),
    };
    setSubmitProgress(90, "מכין את חבילת הקבצים למפעל...");
    const zipUrl = await buildFactoryZip(
      cardRecipient,
      name,
      cardMessage,
      vid || aiVideo ? res.scan_code : null,
      {
        uploadCode: res.upload_code,
        uploadId: res.id,
        orientation: cropOrientation,
        box: boxResult.info,
        video: videoInfo || null,
      },
    );
    const withZip = Object.assign(
      { "_Factory print files (ZIP)": zipUrl },
      baseProperties,
    );
    // Keep Shopify's normal product thumbnail in the cart. The full-resolution factory assets
    // remain in Storage and only their ZIP link is attached to the order.
    setFactoryLineProperties(withZip);
    const attributesResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: withZip }),
    });
    if (!attributesResponse.ok) throw new Error("שמירת קישור קובצי ההדפסה בעגלה נכשלה");
    preparedPieces = pieces;
    preparedUploadCode = String(res.upload_code || "").toUpperCase();
    preparedHasVideo = Boolean(vid || aiVideo);
    personalAddedToCart = false;
    uploadDone = true;
    const w = $("pmGateWarning");
    if (w) w.style.display = "none";
    $("pmSuccessTitle").textContent = aiVideo
      ? "התמונה נשמרה! הסרטון ייווצר אחרי ההזמנה ✨"
      : vid
      ? "התמונה, הסרטון וקובצי ההדפסה נשמרו!"
      : "התמונה וקובצי ההדפסה נשמרו!";
    // Add to the cart the theme's normal way so its cart drawer opens (straight to the cart).
    // hideReplacementAfterCartAdd() then swaps the form for the saved-message state behind the
    // drawer, so the product page keeps showing it if the customer returns to the page.
    const atcBtn = document.querySelector('form[data-type="add-to-cart-form"] [name="add"], form[action*="/cart/add"] [name="add"], form[data-type="add-to-cart-form"] .product-form__submit');
    const atcForm = atcBtn ? atcBtn.closest("form")
      : document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    setSubmitProgress(100, "100% — כל הקבצים מוכנים, מעביר לעגלה...");
    if (submitProgressMessageTimer) clearTimeout(submitProgressMessageTimer);
    submitProgressMessageTimer = null;
    await new Promise((resolve) => setTimeout(resolve, 250));
    if (atcForm && atcForm.requestSubmit) atcForm.requestSubmit(atcBtn && !atcBtn.disabled ? atcBtn : undefined);
    else if (atcBtn && !atcBtn.disabled) atcBtn.click();
  } catch (e) {
    if (submitProgressMessageTimer) clearTimeout(submitProgressMessageTimer);
    submitProgressMessageTimer = null;
    setSubmitProgress(100, "ההעלאה לא הושלמה — אפשר לנסות שוב", true);
    err.textContent = "אירעה שגיאה בהעלאה: " + (e.message || e) + ". נסו שוב.";
    err.style.display = "block";
    btn.disabled = false; btn.style.opacity = "1"; btn.innerHTML = "<span>🛒</span> הוסיפו לעגלה";
  }
});

// If this product is already in the cart with an uploaded file, show the saved-message state
// instead of the upload form — so returning to the page doesn't invite a duplicate upload.
(async function pmRestoreSavedState() {
  try {
    const isNewPersonalFlow = new URLSearchParams(location.search).get("new_personal") === "1";
    if (isNewPersonalFlow) {
      const fw = $("pmFormWrap"), sw = $("pmSuccessWrap"), step = $("pmStep1");
      if (fw) fw.style.display = "block";
      if (sw) sw.style.display = "none";
      requestAnimationFrame(() => step && step.scrollIntoView({ behavior: "smooth", block: "start" }));
      return;
    }
    const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;
    const decoded = decodeURIComponent(handle);
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) return;
    const cart = await res.json();
    const already = (cart.items || []).some(
      (it) => it.handle === decoded && it.properties && it.properties.upload_code
    );
    if (!already) return;
    const fw = $("pmFormWrap"), sw = $("pmSuccessWrap"), t = $("pmSuccessTitle");
    if (t) t.textContent = "קובצי הפאזל נשמרו!";
    if (fw) fw.style.display = "none";
    if (sw) sw.style.display = "block";
  } catch (_) { /* leave the upload form as-is on any error */ }
})();

// Step 1 — piece-count buttons proxy to the theme's hidden variant picker (radios named
// "מספר חלקים"), so choosing pieces updates the variant, price and box spec like normal.
(function pmInitPieceSelector() {
  const buttons = Array.prototype.slice.call(document.querySelectorAll("#pm-upload-root .pm-piece"));
  if (!buttons.length) return;
  const radioFor = (pieces) =>
    document.querySelector('.product__info-container variant-selects input[name="מספר חלקים"][value="' + pieces + ' חלקים"]') ||
    document.querySelector('input[name="מספר חלקים"][value="' + pieces + ' חלקים"]');
  function syncActive() {
    const current = selectedPuzzlePieces();
    buttons.forEach((b) => b.classList.toggle("is-active", String(b.dataset.pieces) === String(current)));
  }
  buttons.forEach((b) =>
    b.addEventListener("click", () => {
      const radio = radioFor(b.dataset.pieces);
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event("change", { bubbles: true })); }
      setTimeout(syncActive, 80);
    })
  );
  document.addEventListener("change", (e) => {
    if (e.target && e.target.name === "מספר חלקים") setTimeout(syncActive, 80);
  });
  syncActive();
})();

// "אפשר לעבור לתשלום" — open the theme's cart drawer (the normal cart look) instead of
// navigating to the full /cart page. Falls back to the /cart link if the drawer isn't available.
const pmGoToCart = $("pmGoToCart");
if (pmGoToCart) {
  pmGoToCart.addEventListener("click", (e) => {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      e.preventDefault();
      // Defer to the next tick so this same click finishes bubbling first — otherwise the
      // drawer's own outside-click handler catches it and closes the drawer immediately.
      setTimeout(() => { try { drawer.open(); } catch (_) { window.location.href = "/cart"; } }, 0);
    }
    // No drawer available → let the link navigate to /cart normally.
  });
}

// "Add another personal puzzle" — reset the flow to a clean upload form so the customer can
// upload a new photo/video and add a second puzzle as its own cart line.
const pmAddAnother = $("pmAddAnother");
if (pmAddAnother) {
  pmAddAnother.addEventListener("click", () => {
    if (submitProgressMessageTimer) clearTimeout(submitProgressMessageTimer);
    submitProgressMessageTimer = null;
    submitProgressVisible = false;
    const progress = $("pmSubmitProgress");
    if (progress) progress.style.display = "none";
    uploadDone = false;
    personalAddedToCart = false;
    preparedPieces = null;
    preparedUploadCode = null;
    preparedHasVideo = false;
    imageUploadPromise = null;
    videoUploadPromise = null;
    boxUploadPromise = null;
    croppedImageFile = null;
    cropSourceFile = null;
    videoOk = false;
    trimSelStart = 0;
    trimSelEnd = null;
    preparedVideoFile = null;
    if (imgURL) { URL.revokeObjectURL(imgURL); imgURL = null; }
    if (vidURL) { URL.revokeObjectURL(vidURL); vidURL = null; }
    setFactoryLineProperties({});
    $("pmImage").value = "";
    $("pmVideo").value = "";
    $("pmName").value = "";
    $("pmRecipient").value = "";
    $("pmMessage").value = "";
    $("pmPreviewImgCell").style.display = "none";
    $("pmPreviewImg").removeAttribute("src");
    $("pmImageLabel").textContent = "לחצו להעלאה";
    $("pmPreviewVidCell").style.display = "none";
    $("pmPreviewVid").removeAttribute("src");
    $("pmVideoLabel").textContent = "לחצו להעלאה • עד 30 שניות";
    showPreview();
    const gate = $("pmGateWarning");
    if (gate) gate.style.display = "none";
    const err2 = $("pmError");
    if (err2) err2.style.display = "none";
    const submit = $("pmSubmitUpload");
    submit.disabled = false;
    submit.style.opacity = "1";
    submit.innerHTML = "<span>🛒</span> הוסיפו לעגלה";
    $("pmSuccessWrap").style.display = "none";
    $("pmFormWrap").style.display = "block";
    if (uploadLauncher) uploadLauncher.style.display = "block";
    const step1 = $("pmStep1");
    if (step1) step1.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}
